var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v(_vm._s(_vm.counter))])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f48c98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/app/components/BoxVersus/WinValue/WinValue.html
// module id = null
// module chunks = 